import React from "react";
import { cloneDeep } from "lodash";
import {
  ResultComparison,
  ScaleComponent,
  GelDragDrop,
} from "@learningblocks/storybook-components";
import "./style.scss";

import {
  getPredictedGel,
  getActualGel,
  //getActualGel2,
  getIdealGel
} from "./commonFunctions"

export class ResultsComparisonGel extends React.Component {

  render() {
    return (
      <ResultComparison
        predictedState={{
          type: "component",
          component: (
            <>
              <p>These are your initial predictions.</p>
              {getPredictedGel(this.props.gelDragDropPrediction)}
            </>
          ),
        }}
        actualState={{
          type: "component",
          component: (
            <>
              <p>These are your actual results.</p>
              {getActualGel(
                this.props.gelExamined,
                this.props.gelOrientation,
                this.props.actualData,
                this.props.level,
                this.props.interactionProps
              )}
            </>
          ),
        }}
        idealState={{
          type: "component",
          component: (
            <>
              <p>These are your ideal results.</p>
              {getIdealGel(
                this.props.idealData,
                this.props.interactionProps
              )}
            </>
          ),
        }}
      />
    );
  }
}